/* eslint-disable no-unsafe-optional-chaining */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable array-callback-return */
/* eslint-disable max-len */
/* eslint-disable no-nested-ternary */
import React, {
  useState, useRef, useEffect, useCallback, useLayoutEffect,
} from 'react';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Dropdown from 'rc-dropdown';
import Menu, { Item as MenuItem } from 'rc-menu';
import IcomoonReact from 'icomoon-react';
import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import moment from 'moment-timezone';
import Shimmer from 'react-shimmer-effect';
import { useDispatch, useSelector } from 'react-redux';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';

import Text from '../../../../shared/components/Text/Text';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import ExerciseTable from './ExerciseTable';
import CalendarItemDropdownOptions from './CalendarItemDropdownOptions';
import PreSaveTable from './PreSaveTable';
import {
  removePresaveItemFromRedux,
  removePresaveProgramItemFromRedux,
  setActiveModal,
  removeSelectedItem,
  setSelectedItem,
  updateCalendarItemsOrder,
  updateWorkoutItemsOrder,
  setCalendarItems,
  setNonDateBasedProgramItems,
  setSuperSetPickerOpenById,
  removeSuperSetPickerOpenById,
  setExpandedItems,
  setPreSaveTableLocalState,
  setActiveExerciseId,
} from '../../ducks/calendarActions';
import PreSaveTableSAQC from './PreSaveTableSAQC';
import ExerciseTableSAQC from './ExerciseTableSAQC';
import ExerciseTableCircuit from './ExerciseTableCircuit';
import PreSaveTableCircuit from './PreSaveTableCircuit';
import hexToRgba from '../../../../shared/utils/hexToRgba';
import QuestionnaireTable from './QuestionnaireTable';
import WarmupTable from './WarmupTable';
import NoteTable from './NoteTable';
import HealthTable from './HealthTable';
import CooldownTable from './CooldownTable';
import SessionBreakTable from './SessionBreakTable';
import RestTimeTable from './RestTimeTable';
import PreSaveRestTimeTable from './PreSaveRestTimeTable';
import PreSaveVideoTable from './PreSaveVideoTable';
import VideoTable from './VideoTable';
import PreSaveProgressionTable from './PreSaveProgressionTable';
import ProgressionTable from './ProgressionTable';
import TagTable from './TagTable';
import SelectDropdownExercisePicker from './SelectDropdownExercisePicker';
import SuperSetPickerPopup from './SuperSetPickerPopup';

const Container = styled('div')`
  position: relative;
`;

const ItemRow = styled('div')`
  display: flex;
  position: relative;
  padding-top: 8px;
  padding-bottom: 8px;
  align-items: center;
  margin-left: ${(props) => (props.isWeekView ? '8px' : '0px')};
  margin-right: ${(props) => (props.isWeekView ? '8px' : '0px')};
  background-color: ${(props) => (props.isActive ? 'rgba(0, 0, 0, 0.02)' : 'transparent')};
  transition: background-color 0.15s ease;
`;

const LineContainer = styled('div')`
  display: flex;
  flex-direction: column;
  margin-left: 10px;
  width: 100%;
  overflow-x: hidden;
`;

const Line = styled('div')`
  position: absolute;
  left: ${(props) => (props.isWeekView ? '38px' : '63px')};
  top: ${(props) => (props.doesGroupingLetterAboveItemMatchContent && !props.isDragging && !props.isHovered ? '0' : '8px')};
  bottom: ${(props) => (props.doesGroupingLetterBelowItemMatchContent && !props.isDragging && !props.isHovered ? '0' : '8px')};
  width: 2px;
  background-color: ${(props) => props.color || '#E74C3C'};
`;

const AbsolutelyPositionedCheckBoxClickArea = styled('div')`
  position: absolute;
  left: 0px;
  top: 0px;
  bottom: 0px;
  width: 62px;
`;

const TextColumn = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
  overflow: hidden;
  margin-left: 7px;
  position: relative;
`;

const Subtext = styled('div')`
  overflow: hidden;
  font-size: 12px;
  color: #9E9E9E;
  font-family: 'Nunito Sans';
  cursor: default;
`;

const SubTitle = styled('div')`
  overflow: hidden;
  font-size: 12px;
  color: #9E9E9E;
  font-family: 'Nunito Sans';
`;

const ExpandingContainer = styled('div')`
  padding-left: 7px;
  padding-right: 7px;
  max-width: 100%;
  overflow: hidden;

  /* Hide the default scrollbar track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;

const PreSaveExpandingContainer = styled('div')`
  display: flex;
  padding-left: 7px;
  padding-right: 7px;
  max-width: 100%;
  overflow: hidden;

  /* Hide the default scrollbar track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;

const NameText = styled('div')`
  font-size: 16px;
  color: #424242;
  font-family: 'Nunito Sans';
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const NameTextAndDownArrowContainer = styled('div')`
display: flex;
gap: 5px;
cursor: pointer;
align-items: center;
max-width: ${(props) => props.maxWidth && props.maxWidth + 20}px;
`;

const RedDashThrough = styled.div`
  width: 24px;
  height: 2px;
  background: #BDBDBD;
  position: absolute;
  transform: rotate(45deg);
  transform-origin: center;
  left: -1px;
  top: 8px;
`;

const IconContainer = styled('div')`
  position: relative;
  background: ${(props) => props.background};
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  border: 1px solid #EEEEEE;
  min-height: 25px;
  min-width: 25px;
  max-width: 25px;
  max-height: 25px;
  border: ${(props) => `1px solid ${props.borderColor}`};
`;

const ParentOrSwapIcon = styled('div')`
  position: absolute;
  top: -9px;
  left: -7px;
  height: 16px;
  width: 16px;
  background: #B5B5B5;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
`;

const DeletedItemIcon = styled('div')`
  position: absolute;
  top: -8px;
  left: -7px;
  height: 18px;
  width: 18px;
  background: #eee787ff;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  z-index: 1000;
`;

const ParentIconBorderBox = styled('div')`
  border: 1px solid white;
  border-radius: 2px;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 12px;
  width: 12px;
  text-align: center;
`;

const IconAndCheckBoxContainer = styled('div')`
display: flex;
height: 100%;
align-self: self-start;
gap: ${(props) => (props.isWeekView ? '0px' : '8px')};
margin-left: 2px;
.checkbox-input {
    visibility: ${(props) => !props.checkboxVisible && 'hidden'};
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${(props) => (props.isChecked ? '#77A7FF' : '#E0E0E0')};
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
    z-index: 10;
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid ${(props) => (props.isChecked ? '#77A7FF' : '#E0E0E0')};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }
`;

const InLineActionsIconContainer = styled('div')`
  display: flex;
  position: relative;
  cursor: pointer;
  border-radius: 4px;
  height: 32px;
  width: 32px;
  min-width: 32px;
  align-items: center;
  justify-content: center;
  :hover {
    background: ${(props) => (props.isDeleteIcon ? 'rgba(255, 5, 5, 0.2)' : 'rgba(119, 167, 255, 0.2)')};
  }

  .inLineActionsIcons {
    fill: rgba(189, 189, 189, 1);
  }

  &:hover .inLineActionsIcons  {
    fill: ${(props) => (props.isDeleteIcon ? '#FF0505' : '#77A7FF')};
  }

`;

const RightBox = styled('div')`
  display: flex;
`;

const RightBoxPlaceholder = styled('div')`
  display: flex;
  visibility: hidden;
`;

const DescriptionText = styled('div')`
  display: flex;
  width: 100%;
`;

const AddDescriptionButton = styled('div')`
  display: flex;
  color: #77A7FF;
  cursor: pointer;
`;

const EditDescriptionButton = styled('div')`
  display: flex;
  color: #77A7FF;
  cursor: pointer;
  display: inline;
  white-space: nowrap;
  margin-left: 5px;
  width: fit-content;
`;

const TextInfoColumn = styled('div')`
  display: flex;
  width: 100%;
  flex-direction: column;
`;

const IconBox = styled('div')`
  display: flex;
   gap: 3px;
`;

const ClickContainer = styled('div')`
  min-height: 32px;
  padding-bottom: ${(props) => props.addPaddingBottom && '5px'};
  display: flex;
  overflow: hidden;
  transition: height 0.3s ease;
  justify-content: space-between;
  align-items: center;
  .rc-menu {
    padding: 10px;
  }
  padding-top: ${(props) => props.isSuperSet && '5px'};
  padding-bottom: ${(props) => (props.type === 'progression' || props.type === 'P') && props.isExpanded && '5px'}
`;

const ShimmerDescription = styled('div')`
  width: 100%;
  max-width: 400px;
  height: 20px;
  border-radius: 4px;
`;

const ConditionalScrollContainer = styled('div')`
  display: flex;
  width: 100%;

  /* Hide the default scrollbar track */
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar {
    width: 6px;
  }
  
  /* Style the scrollbar thumb */
  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 0, 0, 0.2);
    border-radius: 3px;
  }
  
  /* For Firefox */
  scrollbar-width: thin;
  scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
`;

const MenuWrapper = styled('div')`
  .custom-rc-menu {
    border-radius: 4px !important;
    box-shadow: 0px 4px 8px 0px #3031331A !important;
    border: 1px solid #EEEEEE !important;
  
    /* Hide the default scrollbar track */
    &::-webkit-scrollbar-track {
      background: transparent;
    }
    
    /* Style the scrollbar width */
    &::-webkit-scrollbar {
      width: 6px;
    }
    
    /* Style the scrollbar thumb */
    &::-webkit-scrollbar-thumb {
      background-color: rgba(0, 0, 0, 0.2);
      border-radius: 3px;
    }
    
    /* For Firefox */
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.2) transparent;
  }
`;

const AbsoluteText = styled('div')`
  position: absolute;
  top: -22px;
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  color: #5F8BDC;
  font-family: Nunito Sans;
  font-weight: 600;
  font-size: 12px;
  z-index: 5;
`;

const DraggableContent = ({
  localDescription,
  setLocalDescription,
  localAdditionalInfo,
  setLocalAdditionalInfo,
  measure,
  content,
  isHovered,
  itemIsHoveredByMouse,
  itemHoveringOverCurrentItem,
  index,
  isExpanded,
  setIsExpanded,
  checkboxVisible,
  isRecurring,
  beforeOrAfter,
  isDragging,
  shouldShowQuickActions,
  isWeekView,
  isDayExpanded,
  date,
  dayNumber,
  onDayExpand,
  isAthleteAddedItem,
  athleteAddedItems,
}) => {
  const expandingContainerRef = useRef(null);
  const contentRef = useRef(null);
  const exercisePickerTextRef = useRef(null);
  const itemRowRef = useRef(null);
  const inLineActionsContainerRef = useRef(null);
  const textWrapperRef = useRef(null);
  const clickContainerRef = useRef(null);
  const dispatch = useDispatch();
  const selectedItems = useSelector((state) => state.calendar.data.selectedItems);
  const selectedItem = useSelector((state) => (state.calendar.data.selectedItems[content.assignedId]));
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const preSaveAddInfo = useSelector((state) => state.calendar.data.preSaveAddInfo);
  const preSaveDescription = useSelector((state) => state.calendar.data.preSaveDescription);
  const activeModal = useSelector((state) => state.calendar.data.activeModal);
  const isCalendarItemSaving = useSelector((state) => state.calendar.ui.isCalendarItemSaving);
  const calendarItemIndexBeingSaved = useSelector((state) => state.calendar.ui.itemIndexBeingSaved);
  const isCalendarItemUpdating = useSelector((state) => state.calendar.ui.isCalendarItemUpdating);
  const calendarItemIndexBeingUpdated = useSelector((state) => state.calendar.ui.itemIndexBeingUpdated);
  const isCalendarItemSavingOrUpdating = ((isCalendarItemSaving && calendarItemIndexBeingSaved === index) || (isCalendarItemUpdating && calendarItemIndexBeingUpdated === index));
  const programType = useSelector((state) => state.calendar.data.programType);
  const currentUser = useSelector((state) => state.auth.data.currentUser);
  const supersetPickerOpenItems = useSelector((state) => state.calendar.data.isSupersetPickerOpen);
  const isThisItemSupersetPickerOpen = supersetPickerOpenItems[content.assignedId] || false;
  const [supersetDropdownVisible, setSupersetDropdownVisible] = useState(false);
  const preSaveTableLocalState = useSelector((state) => state.calendar.data.preSaveTableLocalState);
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const effectiveDate = date || selectedDate;
  const effectiveSelectedProgramDayNumber = dayNumber || selectedProgramDayNumber;
  const endpointFormattedDate = moment(effectiveDate).format('YYYY-MM-DD');
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      effectiveSelectedProgramDayNumber
    ]?.exercises || []) : useSelector((state) => state.calendar.data.calendarItems[endpointFormattedDate]?.exercises || []);
  const beforeRecurringWorkouts = useSelector((state) => state.calendar.data.beforeRecurringWorkouts[endpointFormattedDate]);
  const afterRecurringWorkouts = useSelector((state) => state.calendar.data.afterRecurringWorkouts[endpointFormattedDate]);
  const weekViewHorizontallyExpandedDay = useSelector(
    (state) => state.calendar.data.weekViewExpandedDay,
  );
  const swapDropdownToggleEnabled = useSelector((state) => state.calendar.data.swapDropdownToggleEnabled);
  const isActiveExercise = useSelector(
    (state) => state.calendar.data.activeExerciseId === content.assignedId,
  );
  const exerciseIsDeletedFromDatabase = content?.type === 'tag' ? content?.tag?.isDeleted : content?.exercise?.isDeleted;
  const [exerciseTextNameWidth, setExerciseTextNameWidth] = useState(null);

  const formatDate = () => `${moment(effectiveDate).format('YYYY-MM-DD')}`;

  const handleRemovePresaveItemFromRedux = () => {
    if (programType === 'free-form-program') {
      dispatch(removePresaveProgramItemFromRedux(effectiveSelectedProgramDayNumber, index, content.assignedId));
    } else {
      dispatch(removePresaveItemFromRedux(formatDate(), index, content.assignedId));
    }
  };

  // Keyboard shortcut: Ctrl/Cmd+D to delete the focused exercise
  useEffect(() => {
    const handleKeyDown = (e) => {
      if ((e.ctrlKey || e.metaKey) && e.key.toLowerCase() === 'd') {
        if (!isActiveExercise) return;
        e.preventDefault();

        if (content.preSave) {
          handleRemovePresaveItemFromRedux();
        } else {
          const isParentCalendarItem = content.isInherited;
          dispatch(setActiveModal('confirmDeleteModal', {
            assignedId: content.assignedId,
            itemIndex: index,
            isRecurring,
            isParentCalendarItem,
            ...(programType === 'free-form-program' && { dayNumber: effectiveSelectedProgramDayNumber }),
            ...(isWeekView && { date: effectiveDate }),
          }));
        }
      }
    };
    window.addEventListener('keydown', handleKeyDown);
    return () => window.removeEventListener('keydown', handleKeyDown);
  }, [isActiveExercise, content, index, isRecurring, programType, effectiveSelectedProgramDayNumber, isWeekView, effectiveDate]);

  let doesGroupingLetterAboveItemMatchContent;
  let doesGroupingLetterBelowItemMatchContent;

  if (isRecurring) {
    if (isRecurring === 'before') {
      const indexInBefore = beforeRecurringWorkouts?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInBefore > 0
        && content.groupingLetter === beforeRecurringWorkouts?.[indexInBefore - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInBefore !== -1
        && content.groupingLetter === beforeRecurringWorkouts?.[indexInBefore + 1]?.groupingLetter;
    }
    if (isRecurring === 'after' && !isAthleteAddedItem) {
      const indexInAfter = afterRecurringWorkouts?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInAfter > 0
        && content.groupingLetter === afterRecurringWorkouts?.[indexInAfter - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInAfter !== -1
        && content.groupingLetter === afterRecurringWorkouts?.[indexInAfter + 1]?.groupingLetter;
    }
    if (isRecurring === 'after' && isAthleteAddedItem) {
      const indexInAfter = athleteAddedItems?.findIndex((w) => w.assignedId === content.assignedId);

      doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
        && indexInAfter > 0
        && content.groupingLetter === athleteAddedItems?.[indexInAfter - 1]?.groupingLetter;

      doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
        && indexInAfter !== -1
        && content.groupingLetter === athleteAddedItems?.[indexInAfter + 1]?.groupingLetter;
    }
  } else {
    doesGroupingLetterAboveItemMatchContent = !!content.groupingLetter
    && content.groupingLetter === calendarItems[index - 1]?.groupingLetter;

    doesGroupingLetterBelowItemMatchContent = !!content.groupingLetter
    && content.groupingLetter === calendarItems[index + 1]?.groupingLetter;
  }

  /** this is the selected option in the select dropdown picker for the name of the exercise
   * we need to pull it out of the picker and put it on this level so we can pass it to the tables
   */
  const [selectedOption, setSelectedOption] = useState(null);

  const typeDoesNotExpand = () => false;

  const typeDoesNotHaveTable = () => {
    if (content.type === 'warm_up' || content.type === 'W' || content.type === 'health' || content.type === 'H' || content.type === 'note' || content.type === 'N' || content.type === 'cooldown' || content.type === 'CD') {
      return true;
    }
    return false;
  };

  const typeHasSwap = () => {
    if (content.type === 'session_break' || content.type === 'rest' || content.type === 'video' || content.type === 'P' || content?.exercise?.type === 'P') {
      return false;
    }
    return true;
  };

  const typeHasIndividualScrollContainer = () => {
    if (content?.type === 'L' || content?.type === 'C' || content?.type === 'T' || content?.type === 'R') {
      return true;
    }
    return false;
  };

  const completionOnlySetting = () => {
    /** if the item is not a preSave item, meaning it is a saved item
     * getting returned from the update endpoint or from the get clalendar items
     * endpoint then we need to check if the original exercise is a circuit
     * and then check if that original exercise is of type 'C' for completion only
     * the other types should return completionOnly on the content
     */
    if (!content.preSave) {
      if (content?.exercise?.type === 'C' || content?.exercise?.type === 'circuit' || content.exercise?.inputType === 'C') {
        return true;
      }
      return content?.completionOnly;
    }
    /** if it IS a presaved item then we can grab these properties off the content */
    if (content.type === 'L') {
      return !!content.defaultOptions?.liftComp;
    }
    if (content.type === 'R') {
      if (content.inputType === 'C' || !!content.defaultOptions?.cardioComp) {
        return true;
      }
    }
    if (content.type === 'C') {
      return true;
    }
    return false;
  };

  const coachCompletionSetting = () => {
    if (!content.preSave) return !!content?.coachCompletion;
    if (content.type === 'L') {
      return !!content.defaultOptions?.liftCoachComp;
    }
    if (content.type === 'R') {
      return !!content.defaultOptions?.cardioCoach;
    }
    if (content.type === 'C') {
      return !!content.defaultOptions?.circuitCoach;
    }
    return false;
  };

  const getInitialStateForDisablePrUpdate = () => {
    if (content.type === 'lift' || content.type === 'L') {
      if (content.preSave ? (content?.track === 0) : !!content?.maxTrackingDisabled) {
        return true;
      }
      return false;
    }
    return false;
  };

  const [windowWidth, setWindowWidth] = useState(0);
  const [coachCompletion, setCoachCompletion] = useState(coachCompletionSetting());
  const [completionOnly, setCompletionOnly] = useState(completionOnlySetting());
  const [trackVolumeLoad, setTrackVolumeLoad] = useState(
    content.preSave ? !!content.defaultOptions?.trackVolLoad : !!content?.trackVolumeLoad,
  );
  const [isLeftAndRight, setIsLeftAndRight] = useState(
    content.preSave ? !!content.defaultOptions?.eachSide : !!content?.eachSide,
  );
  const [trackRepCount, setTrackRepCount] = useState(
    content.preSave ? !!content.defaultOptions?.trackRepCount : !!content?.trackRepCount,
  );
  const [forcePrUpdate, setForcePrUpdate] = useState(content.preSave ? !!content.defaultOptions?.forceMaxUpdate : !!content?.forceMaxUpdate);
  const [disablePrUpdate, setDisablePrUpdate] = useState(getInitialStateForDisablePrUpdate());
  const [assignedPace, setAssignedPace] = useState(
    content.preSave ? (content.defaultOptions?.pacing || '') : (content?.pacing || ''),
  );

  // Callback to save dropdown state to Redux
  const saveDropdownStateToRedux = useCallback((overrides = {}) => {
    const dropdownState = {
      coachCompletion,
      completionOnly,
      isLeftAndRight,
      trackVolumeLoad,
      trackRepCount,
      forcePrUpdate,
      disablePrUpdate,
      ...overrides, // Override stale closure values with fresh ones
    };
    dispatch(setPreSaveTableLocalState(content.assignedId, dropdownState));
  }, [
    coachCompletion,
    completionOnly,
    isLeftAndRight,
    trackVolumeLoad,
    trackRepCount,
    forcePrUpdate,
    disablePrUpdate,
    content.assignedId,
    dispatch,
  ]);

  const nonSwappedItemFromParentCalendar = content.isInherited && !content.swap;

  const [iconOb, setIconOb] = useState({
    coachCompletionToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Coach completion',
      icon: 'coach-completion',
      enabled: false,
    },
    completionOnlyToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Completion only',
      icon: 'completion-circle',
      enabled: false,
    },
    trackVolumeLoadToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Track volume load',
      icon: 'pr-tracking',
      enabled: false,
    },
    eachSideToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Each side',
      icon: 'trashcan',
      enabled: false,
    },
    trackRepCountToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Track rep count',
      icon: 'send',
      enabled: false,
    },
    forcePrUpdateToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Force PR update',
      icon: 'force-pr-update',
      enabled: false,
    },
    disablePrUpdateToggle: {
      id: generateUniqueId()?.toString(),
      label: 'PR update disabled',
      icon: 'force-pr-update',
      enabled: false,
      extra: <RedDashThrough />,
    },
    additionalInfoToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Additional Information Added',
      icon: 'note2',
      enabled: !!localAdditionalInfo || !!content.additionalInfo,
    },
    swapDropdownToggle: {
      id: generateUniqueId()?.toString(),
      label: 'Swap',
      icon: null,
      enabled: swapDropdownToggleEnabled === content?.assignedId,
    },
  });

  const getItemsUnderSessionBreak = (currentItem) => {
    const items = beforeOrAfter === 'before' ? beforeRecurringWorkouts : beforeOrAfter === 'after' ? afterRecurringWorkouts : calendarItems;
    if (!currentItem || currentItem.type !== 'session_break') return {};

    const currentIndex = items.findIndex(
      (c) => c?.assignedId === currentItem?.assignedId,
    );
    if (currentIndex === -1) return {};

    const result = {};
    let reachedNextBreak = false;

    items.map((calItem, i) => {
      if (i <= currentIndex || reachedNextBreak) return;
      if (calItem.type === 'session_break') {
        reachedNextBreak = true;
        return;
      }
      result[calItem.assignedId] = calItem;
    });

    return result;
  };

  const NumberOfItemsUnderSessionBreak = Object?.values(getItemsUnderSessionBreak(content))?.length ? Object?.values(getItemsUnderSessionBreak(content))?.length : 0;

  const handleCheckboxChange = () => {
    if (content?.type === 'session_break') {
      const itemsUnder = getItemsUnderSessionBreak(content);
      const allIds = [content.assignedId, ...Object.keys(itemsUnder)];

      /** Check if the session break itself is selected */
      const isSelected = allIds.some((id) => selectedItems[id]);

      if (isSelected) {
      /** Deselect session break and all items under it */
        allIds.forEach((id) => {
          const itemToRemove = selectedItems[id];
          if (itemToRemove) {
            dispatch(removeSelectedItem(itemToRemove));
          }
        });
      } else {
      /** Select session break and all items under it */
        dispatch(setSelectedItem(content));
        Object.values(itemsUnder).forEach((item) => {
          dispatch(setSelectedItem(item));
        });
      }
    } else {
    /** Regular item toggle */
      // eslint-disable-next-line no-lonely-if
      if (selectedItem) {
        dispatch(removeSelectedItem(content));
      } else {
        dispatch(setSelectedItem(content));
      }
    }
  };

  const inLineActionsObject = {
    expandOrCollapse: {
      id: generateUniqueId()?.toString(),
      label: isExpanded ? 'Collapse' : 'Expand',
      icon: isExpanded ? 'collapse' : 'expand2',
      onClick: ((!content.preSave && !typeDoesNotExpand()) && setIsExpanded),
      enabled: !typeDoesNotExpand() && !content.preSave,
    },
    superSet: {
      id: generateUniqueId()?.toString(),
      label: 'Superset',
      icon: 'superset',
      onClick: () => {},
      enabled: content?.type !== 'session_break' && content?.type !== 'questionnaire',
    },
    moveUp: {
      id: generateUniqueId()?.toString(),
      label: 'Move up',
      icon: 'alt-up-arrow',
      onClick: () => {
        if (!isRecurring && index !== 0 && calendarItems?.length !== 1) {
          const originalItems = [...calendarItems];
          const newItems = Array.from(calendarItems);
          const [removed] = newItems.splice(index, 1);
          newItems.splice(index - 1, 0, removed);
          const newOrderedAssignmentIds = [];
          newItems.forEach((calendarItem) => {
            if (typeof calendarItem.assignedId !== 'string') {
              newOrderedAssignmentIds.push(calendarItem.assignedId);
            }
          });

          if (programType === 'free-form-program') {
            const submissionObject = {
              dayNumber: effectiveSelectedProgramDayNumber,
              order: newOrderedAssignmentIds,
            };

            if (newOrderedAssignmentIds?.length) {
              dispatch(updateWorkoutItemsOrder(currentUser.accountCode, submissionObject, originalItems));
              dispatch(setNonDateBasedProgramItems(newItems, effectiveSelectedProgramDayNumber));
            }
          } else {
            const submissionObject = {
              date: moment(effectiveDate).format('YYYY-MM-DD'),
              order: newOrderedAssignmentIds,
            };

            if (newOrderedAssignmentIds?.length) {
              dispatch(updateCalendarItemsOrder(currentUser.accountCode, submissionObject, originalItems));
              dispatch(setCalendarItems(newItems, moment(effectiveDate).format('YYYY-MM-DD')));
            }
          }
        }
      },
      enabled: !isRecurring && index !== 0 && calendarItems?.length !== 1,
    },
    moveDown: {
      id: generateUniqueId()?.toString(),
      label: 'Move down',
      icon: 'alt-down-arrow',
      onClick: () => {
        if (!isRecurring && calendarItems?.length > 1 && index !== calendarItems?.length - 1) {
          const originalItems = [...calendarItems];
          const newItems = Array.from(calendarItems);
          const [removed] = newItems.splice(index, 1);
          newItems.splice(index + 1, 0, removed);

          const newOrderedAssignmentIds = [];
          newItems.forEach((calendarItem) => {
            if (typeof calendarItem.assignedId !== 'string') {
              newOrderedAssignmentIds.push(calendarItem.assignedId);
            }
          });

          if (programType === 'free-form-program') {
            const submissionObject = {
              dayNumber: effectiveSelectedProgramDayNumber,
              order: newOrderedAssignmentIds,
            };
            if (newOrderedAssignmentIds?.length) {
              dispatch(updateWorkoutItemsOrder(currentUser.accountCode, submissionObject, originalItems));
              dispatch(setNonDateBasedProgramItems(newItems, effectiveSelectedProgramDayNumber));
            }
          } else {
            const submissionObject = {
              date: moment(effectiveDate).format('YYYY-MM-DD'),
              order: newOrderedAssignmentIds,
            };

            if (newOrderedAssignmentIds?.length) {
              dispatch(updateCalendarItemsOrder(currentUser.accountCode, submissionObject, originalItems));
              dispatch(setCalendarItems(newItems, moment(effectiveDate).format('YYYY-MM-DD')));
            }
          }
        }
      },
      enabled: !isRecurring && calendarItems?.length > 1
      && index !== calendarItems?.length - 1,
    },
    delete: {
      id: generateUniqueId()?.toString(),
      label: 'Delete',
      icon: 'delete',
      onClick: () => {
        if (content.preSave) {
          handleRemovePresaveItemFromRedux();
        } else {
          // Show confirmation modal instead of direct deletion
          const isParentCalendarItem = content.isInherited;
          dispatch(setActiveModal('confirmDeleteModal', {
            assignedId: content.assignedId,
            itemIndex: index,
            isRecurring,
            isParentCalendarItem,
            ...(programType === 'free-form-program' && { dayNumber }),
            ...(isWeekView && { date: effectiveDate }),
          }));
        }
      },
      enabled: true,
    },
  };

  const isChecked = !!selectedItem;

  useEffect(() => {
    // GUARD: Don't reset if backup exists - user has made changes
    const backup = preSaveTableLocalState[content.assignedId];
    if (backup) {
      return; // Let PreSaveTable's restoration useEffect handle it
    }

    // Only reset from defaultOptions if no backup exists
    const newIconOb = { ...iconOb };
    const { preSave } = content;
    const defaultOptions = content?.defaultOptions || {};

    newIconOb.coachCompletionToggle.enabled = coachCompletionSetting();
    newIconOb.completionOnlyToggle.enabled = completionOnlySetting();
    newIconOb.eachSideToggle.enabled = preSave ? !!defaultOptions?.eachSide : !!content?.eachSide;
    newIconOb.trackVolumeLoadToggle.enabled = preSave ? !!defaultOptions?.trackVolLoad : !!content?.trackVolumeLoad;
    newIconOb.trackRepCountToggle.enabled = preSave ? !!defaultOptions?.trackRepCount : !!content?.trackRepCount;
    newIconOb.forcePrUpdateToggle.enabled = preSave ? !!defaultOptions?.forceMaxUpdate : !!content?.forceMaxUpdate;

    if (content.type === 'lift' || content.type === 'L' || content.type === 'T' || content.type === 'tag') {
      newIconOb.disablePrUpdateToggle.enabled = preSave ? content?.track === 0 : !!content?.maxTrackingDisabled;
    }
    setIconOb(newIconOb);
    /** if conent changes we need to reselt the select dropdown
     * so that the name of the exercise reflects the updated content
     * this is important if a call fails and you have an out of sync exericse
     * name relfected in the exercise picker
     */
    setSelectedOption(null);
  }, [content, preSaveTableLocalState]);

  useEffect(() => {
    const matchedInfo = preSaveAddInfo?.find((info) => info.id === content?.id);

    if (matchedInfo) {
      setLocalAdditionalInfo(matchedInfo.content);
    }
  }, [preSaveAddInfo, content?.id]);

  /** watch for updates in additional info and set the pill icon to enabled if user
   adds additional info
   */
  useEffect(() => {
    const newIconOb = { ...iconOb };
    newIconOb.additionalInfoToggle.enabled = !!localAdditionalInfo || content.additionalInfo;
    setIconOb(newIconOb);
  }, [localAdditionalInfo, content]);

  useEffect(() => {
    const matchedInfo = preSaveDescription?.find((desc) => desc.id === content?.id);

    if (matchedInfo) {
      setLocalDescription(matchedInfo.content);
    }
  }, [preSaveDescription, content?.id]);

  /** Update window width on resize */
  useEffect(() => {
    const handleResize = () => {
      setWindowWidth(window.innerWidth);
    };
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    setSupersetDropdownVisible(isThisItemSupersetPickerOpen);

    const handleResize = () => {
      if (supersetDropdownVisible) {
        setSupersetDropdownVisible(false);
      }
    };

    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [isThisItemSupersetPickerOpen]);

  const iconColorWriter = (icon) => {
    if (icon === 'question-mark-circle') {
      return '#9B59B6';
    }
    if (icon === 'science') {
      return '#9B59B6';
    }
    if (icon === 'warmup') {
      return '#E74C3C';
    }
    if (icon === 'lift') {
      return '#6C7A89';
    }
    if (icon === 'cardio') {
      return '#59ABE3';
    }
    if (icon === 'circuit') {
      return '#F89406';
    }
    if (icon === 'cooldown') {
      return '#1787FB';
    }
    if (icon === 'health' || icon === 'heart') {
      return '#E74C3C';
    }
    if (icon === 'note') {
      return '#F9BF3B';
    }
    if (icon === 'chart') {
      return '#FF00BF';
    }
    if (icon === 'tag2' || icon === 'tag') {
      return '#FF4500';
    }
    if (icon === 'page-break' || icon === 'break') {
      return 'white';
    }
    if (icon === 'rest' || icon === 'clock') {
      return '#6C7A89';
    }
    if (icon === 'video-add' || icon === 'video') {
      return '#6C7A89';
    }
    if (icon === 'plus') {
      return '#9E9E9E';
    }
    return '';
  };

  const iconBackgroundColor = ({ line }) => {
    const icon = content.groupingLetter ? 'groupingLetter' : content.icon;
    if (icon === 'question-mark-circle') {
      return 'rgba(155, 89, 182, 0.2)';
    }
    if (icon === 'science') {
      return 'rgba(155, 89, 182, 0.2)';
    }
    if (icon === 'warmup') {
      return 'rgba(231, 76, 60, 0.2)';
    }
    if (icon === 'lift') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'cardio') {
      return 'rgba(89, 171, 227, 0.2)';
    }
    if (icon === 'circuit') {
      return 'rgba(248, 148, 6, 0.2)';
    }
    if (icon === 'cooldown') {
      return 'rgba(23, 135, 251, 0.2)';
    }
    if (icon === 'health' || icon === 'heart') {
      return 'rgba(231, 76, 60, 0.2)';
    }
    if (icon === 'note') {
      return 'rgba(249, 191, 59, 0.2)';
    }
    if (icon === 'chart') {
      return 'rgba(255, 0, 191, 0.2)';
    }
    if (icon === 'tag2' || icon === 'tag') {
      return 'rgba(255, 69, 0, 0.2)';
    }
    if (icon === 'page-break' || icon === 'break') {
      if (line) {
        return 'rgba(108, 122, 137, 0.2)';
      }
      return '#34495e';
    }
    if (icon === 'rest' || icon === 'clock') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'video-add' || icon === 'video') {
      return 'rgba(108, 122, 137, 0.2)';
    }
    if (icon === 'plus') {
      return 'white';
    }
    if (icon === 'groupingLetter') {
      return hexToRgba(content?.groupingColorCode, 0.2);
    }
    return '';
  };

  const accessoryItem = (icon) => {
    if (icon === 'rest' || icon === 'clock') {
      return true;
    }
    if (icon === 'video-add' || icon === 'video') {
      return true;
    }
    if (icon === 'plus') {
      return true;
    }
    return false;
  };

  const inLineActionsIconDisplayer = (iconObArg) => {
    const iconKeys = Object.keys(iconObArg);
    const icoSet = iconKeys.map((key) => {
      const iconObject = iconObArg[key];
      if (iconObject.enabled && iconObject.icon) {
        return (
          <React.Fragment key={generateUniqueId()}>
            {iconObject.label === 'Superset' ? (
              <Dropdown
                trigger={['click']}
                overlay={(
                  <MenuWrapper onClick={(e) => e.stopPropagation()}>
                    <Menu
                      className='custom-rc-menu superset-picker-menu'
                      style={{
                        width: 'auto',
                        minHeight: 50,
                        maxHeight: 300,
                        overflowY: 'auto',
                        border: '1px solid #eeeeee',
                        background: 'white',
                      }}
                    >
                      <MenuItem
                        key='superset-picker'
                        style={{ padding: 0, margin: 0 }}
                      >
                        <SuperSetPickerPopup content={content} left={0} top={0} isRecurring={isRecurring} setSuperSetDropdownVisible={setSupersetDropdownVisible} inLineAction effectiveDate={effectiveDate} dayNumber={dayNumber} />
                      </MenuItem>
                    </Menu>
                  </MenuWrapper>
                )}
                visible={supersetDropdownVisible}
                onVisibleChange={(visible) => {
                  setSupersetDropdownVisible(visible);
                  if (visible) {
                    dispatch(setSuperSetPickerOpenById(content.assignedId));
                  } else {
                    dispatch(removeSuperSetPickerOpenById(content.assignedId));
                  }
                }}
              >
                <InLineActionsIconContainer data-tooltip-id={iconObject.id} onClick={iconObject.onClick} isDeleteIcon={iconObject.icon === 'delete'}>
                  <IcomoonReact
                    iconSet={iconSet}
                    size={iconObject?.icon === 'superset' ? 30 : 15}
                    icon={iconObject.icon}
                    className='inLineActionsIcons'
                  />
                  {iconObject.extra}
                </InLineActionsIconContainer>
              </Dropdown>
            ) : (
              <InLineActionsIconContainer data-tooltip-id={iconObject.id} onClick={iconObject.onClick} isDeleteIcon={iconObject.icon === 'delete'}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={15}
                  icon={iconObject.icon}
                  className='inLineActionsIcons'
                />
                {iconObject.extra}
              </InLineActionsIconContainer>
            )}
            <ReactTooltip
              id={iconObject.id}
              place='top'
              content={`${iconObject.label}`}
              style={{
                backgroundColor: 'rgba(68, 68, 68, 1)',
                color: 'white',
                fontFamily: 'Nunito Sans',
                fontSize: '13px',
                zIndex: 1000,
              }}
            />
          </React.Fragment>
        );
      }
      return null;
    });
    return icoSet;
  };

  const decodeHtmlEntities = (str) => {
    if (!str) return str;
    return str
      .replace(/&apos;/g, '\'')
      .replace(/&quot;/g, '"')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>');
  };

  const paceDisplaySection = () => {
    // Only show pace for SAQC items (type 'R') that have an assigned pace
    if ((content.type === 'R' || content?.exercise?.type === 'R') && assignedPace) {
      return (
        <div style={{ marginBottom: '8px' }}>
          <Text fontSize='12px' color='#9E9E9E' style={{ fontFamily: 'Nunito Sans' }}>
            Pace:
            {' '}
            {assignedPace}
          </Text>
        </div>
      );
    }
    return null;
  };

  const infoEditSection = (paramContent) => (
    paramContent.type === 'T' || paramContent.type === 'tag' || paramContent.type === 'S' || paramContent.type === 'questionnaire' || paramContent.typeDescription === 'lift' || (paramContent.exercise && (paramContent.exercise.typeDescription === 'lift' || paramContent.exercise.type === 'T' || paramContent.exercise.type === 'S')) ? (
      <TextInfoColumn>
        <DescriptionText>
          {(isCalendarItemSavingOrUpdating && (activeModal !== 'addAdditionalInfoModal') && typeDoesNotHaveTable()) ? (
            <Shimmer>
              <ShimmerDescription />
            </Shimmer>
          ) : (
            <>
              {localAdditionalInfo || paramContent?.additionalInfo || paramContent?.exercise?.additionalInfo ? null : (
                <AddDescriptionButton onClick={(e) => {
                  e.stopPropagation();
                  dispatch(setActiveModal('addAdditionalInfoModal', {
                    ...content, itemIndex: index, effectiveDate, dayNumber, isRecurring,
                  }));
                }}
                >
                  + Add Additional Info
                </AddDescriptionButton>
              )}
              <span style={{ fontFamily: 'nunito sans' }}>
                {localAdditionalInfo || decodeHtmlEntities(paramContent?.additionalInfo) || decodeHtmlEntities(paramContent.exercise?.additionalInfo)}
                {(!paramContent?.additionalInfo && !paramContent.exercise?.additionalInfo && !localAdditionalInfo) ? null : (
                  <EditDescriptionButton
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(setActiveModal('addAdditionalInfoModal', {
                        ...content, itemIndex: index, effectiveDate, dayNumber, isRecurring,
                      }));
                    }}
                  >
                    Edit
                  </EditDescriptionButton>
                )}
              </span>
            </>
          )}
        </DescriptionText>
      </TextInfoColumn>
    ) : (
      <TextInfoColumn>
        {((paramContent.type === 'circuit' && paramContent.subTitle) || (paramContent.type === 'C' && paramContent.subTitle)) && (
        <DescriptionText>
          {paramContent.subTitle}
          {decodeHtmlEntities(paramContent.description) && ' '}
        </DescriptionText>
        )}
        {paramContent.type === 'progression' || paramContent.typeDescription === 'progression' || (paramContent.exercise && (paramContent.exercise.type === 'P')) ? <Text color='#9E9E9E' fontSize='12px' style={{ marginBottom: 5 }}>Athlete will be shown the selected step that corresponds to their level.</Text> : (
          <DescriptionText style={{ flexDirection: 'column' }}>
            {(isCalendarItemSavingOrUpdating && (activeModal !== 'addDescriptionModal') && typeDoesNotHaveTable()) ? (
              <Shimmer>
                <ShimmerDescription />
              </Shimmer>
            ) : (
              <>
                {localDescription || paramContent?.description || paramContent?.exercise?.description ? null : (
                  <AddDescriptionButton onClick={(e) => {
                    e.stopPropagation();
                    dispatch(setActiveModal('addDescriptionModal', {
                      ...content, itemIndex: index, effectiveDate, dayNumber, isRecurring,
                    }));
                  }}
                  >
                    + Add Description
                  </AddDescriptionButton>
                )}
                <span style={{ fontFamily: 'nunito sans', whiteSpace: 'pre-wrap' }}>
                  {localDescription || decodeHtmlEntities(paramContent?.description) || decodeHtmlEntities(paramContent.exercise?.description)}
                </span>
                {(!paramContent?.description && !paramContent.exercise?.description && !localDescription) || paramContent?.typeDescription === 'lift' || paramContent?.exercise?.typeDescription === 'lift' ? null : (
                  <EditDescriptionButton
                    style={{ marginLeft: 0 }}
                    onClick={(e) => {
                      e.stopPropagation();
                      dispatch(setActiveModal('addDescriptionModal', {
                        ...content, itemIndex: index, effectiveDate, dayNumber, isRecurring,
                      }));
                    }}
                  >

                    Edit
                  </EditDescriptionButton>
                )}
              </>
            )}
          </DescriptionText>
        )}
      </TextInfoColumn>
    )
  );

  const typeResolver = () => {
    if (content?.type === 'session_break') {
      return 'session_break';
    }
    if (content?.type === 'rest') {
      return 'rest';
    }
    if (content?.preSave) {
      return content?.type;
    }
    return content?.exercise?.type;
  };

  const excludedDescriptionTypes = [
    'P',
    'video',
    'rest',
    'health',
    'H',
    'session_break',
  ];

  const getName = () => {
    if (content.type === 'video' && !content.title) {
      return 'Video';
    }
    if (content.type === 'session_break' && (!content.title || content.title === 'Session')) {
      return 'Session Break';
    }
    if (content.type === 'rest') {
      if (content.restTime) {
        return `Rest Time (${content?.restTime} sec)`;
      }
      return 'Rest Time';
    }
    return content.title;
  };

  const [addExerciseToggleMenuOpen, setAddExerciseToggleMenuOpen] = useState(false);
  const [sessionBreakInputOpen, setSessionBreakInputOpen] = useState(false);
  const [sessionBreakInputValue, setSessionBreakInputValue] = useState(content?.title === 'Session' ? '' : content?.title);

  useLayoutEffect(() => {
    if (exercisePickerTextRef.current) {
      requestAnimationFrame(() => {
        setExerciseTextNameWidth(exercisePickerTextRef?.current?.offsetWidth);
      });
    }
  }, [addExerciseToggleMenuOpen, getName()]);

  return (
    <Container onClickCapture={() => dispatch(setActiveExerciseId(content.assignedId))}>
      {isHovered && content.type !== 'session_break' && content.type !== 'questionnaire' && itemHoveringOverCurrentItem?.type !== 'session_break' && itemHoveringOverCurrentItem?.type !== 'questionnaire' ? (
        content.groupingLetter ? (
          <AbsoluteText>Add to Superset</AbsoluteText>
        ) : (
          <AbsoluteText>Drop to Create a Superset</AbsoluteText>
        )
      ) : null}
      <ItemRow
        ref={itemRowRef}
        data-exercise-item
        isActive={isActiveExercise}
        onClick={() => {
          if (isWeekView && !isDayExpanded && onDayExpand) {
            // Clear all expanded items in other day columns first
            dispatch(setExpandedItems({}));
            onDayExpand();
            if (!content.preSave && !typeDoesNotExpand()) {
              /** commenting this out for now if click on item and
               * we need to expand horizontally and vertically measure()
               * is having time getting correct size for notes, warm ups, cooldowns
               * etc. basically the text based tables
               */
              // setIsExpanded(true);
            }
          } else {
            !content.preSave && !typeDoesNotExpand() && setIsExpanded(true);
          }
        }}
        style={{ opacity: (isHovered && content.type !== 'session_break' && content.type !== 'questionnaire' && itemHoveringOverCurrentItem?.type !== 'session_break' && itemHoveringOverCurrentItem?.type !== 'questionnaire') ? 0.5 : 1 }}
        doesGroupingLetterAboveItemMatchContent={doesGroupingLetterAboveItemMatchContent}
        doesGroupingLetterBelowItemMatchContent={doesGroupingLetterBelowItemMatchContent}
        isWeekView={isWeekView}
      >
        <IconAndCheckBoxContainer
          checkboxVisible={((isCalendarItemSaving && typeDoesNotExpand() && !isChecked)) ? false : checkboxVisible}
          isChecked={isChecked}
          isWeekView={((isWeekView && String(weekViewHorizontallyExpandedDay) !== String(programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : endpointFormattedDate)))}
        >
          {(!isWeekView || (isWeekView && String(weekViewHorizontallyExpandedDay) === String(programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : endpointFormattedDate))) && (
            <input
              className='checkbox-input'
              type='checkbox'
              name={content?.exercise?.name}
              checked={isChecked}
              onClick={(event) => {
                event.stopPropagation();
                handleCheckboxChange();
              }}
            />
          )}
          <IconContainer background={accessoryItem(content.icon) && !content.groupingLetter ? 'white' : iconBackgroundColor({ line: false })} borderColor={iconBackgroundColor({ line: false })}>
            {content.groupingLetter ? (
              <Text fontSize='13px' color={content.groupingColorCode}>{content.groupingLetter}</Text>
            ) : (
              <IcomoonReact
                iconSet={iconSet}
                size={15}
                icon={content.icon === 'break' ? 'page-break' : content.icon}
                color={iconColorWriter(content.icon)}
              />
            )}
            {content.isInherited && !exerciseIsDeletedFromDatabase && (
              <>
                <ParentOrSwapIcon
                  data-tooltip-id={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                >
                  <ParentIconBorderBox>
                    <Text fontSize={10} style={{ marginTop: 3 }} color='white'>
                      P
                    </Text>
                  </ParentIconBorderBox>
                </ParentOrSwapIcon>
                <ReactTooltip
                  id={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  key={`parent-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  place='top'
                  content='From Parent Calendar'
                  style={{
                    zIndex: 9999,
                    backgroundColor: 'rgba(68, 68, 68, 1)',
                    color: 'white',
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
              </>
            )}
            {content?.swap && !exerciseIsDeletedFromDatabase && (
              <>
                <ParentOrSwapIcon
                  data-tooltip-id={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                >
                  <IcomoonReact
                    iconSet={iconSet}
                    size={10}
                    icon='swap'
                    color='white'
                  />
                </ParentOrSwapIcon>
                <ReactTooltip
                  id={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  key={`swapped-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                  place='top'
                  content='Swapped Exercise'
                  style={{
                    zIndex: 9999,
                    backgroundColor: 'rgba(68, 68, 68, 1)',
                    color: 'white',
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
              </>
            )}
            {exerciseIsDeletedFromDatabase && (
            <>
              <DeletedItemIcon data-tooltip-id={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}>
                <IcomoonReact
                  iconSet={iconSet}
                  size={12}
                  icon='warning'
                />
              </DeletedItemIcon>
              <ReactTooltip
                id={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                key={`deletedItem-${content.exerciseId}-${isRecurring}-${programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : effectiveDate}`}
                place='top'
                positionStrategy='fixed'
                content={isAthleteAddedItem ? 'This item added by the athlete is no longer in your database. You can view records of this in workout results, but max/PR data will not be available.' : `This item ${content?.isInherited ? 'is inherited from a parent calendar and ' : ''}is no longer in your library. It will appear to athletes but data will be limited. We suggest you delete each occurrence or update future occurrences to swap all.`}
                style={{
                  zIndex: 9999,
                  backgroundColor: 'rgba(68, 68, 68, 1)',
                  color: 'white',
                  fontFamily: 'Nunito Sans',
                  fontSize: '13px',
                  maxWidth: (isWeekView && String(weekViewHorizontallyExpandedDay) !== String(programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : endpointFormattedDate)) ? '175px' : '250px',
                  whiteSpace: 'normal',
                  wordBreak: 'break-word',
                }}
              />
            </>
            )}
          </IconContainer>
        </IconAndCheckBoxContainer>
        <LineContainer>
          {(!isWeekView || (isWeekView && String(weekViewHorizontallyExpandedDay) === String(programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : endpointFormattedDate))) && (
          <AbsolutelyPositionedCheckBoxClickArea
            style={{ zIndex: 999 }}
            onClick={(event) => {
              event.stopPropagation();
              handleCheckboxChange();
            }}
          />
          )}
          <Line
            isHovered={isHovered}
            isDragging={isDragging}
            color={
            content.groupingColorCode
              ? content.groupingColorCode
              : iconBackgroundColor({ line: true })
            }
            doesGroupingLetterAboveItemMatchContent={doesGroupingLetterAboveItemMatchContent}
            doesGroupingLetterBelowItemMatchContent={doesGroupingLetterBelowItemMatchContent}
            isWeekView={((isWeekView && String(weekViewHorizontallyExpandedDay) !== String(programType === 'free-form-program' ? effectiveSelectedProgramDayNumber : endpointFormattedDate)))}
          />
          <ClickContainer
            isExpanded={isExpanded || content.preSave || typeDoesNotExpand()}
            isPreSave={content.preSave}
            ref={clickContainerRef}
            addPaddingBottom={content.type === 'session_break' && isExpanded}
            type={content.type}
          >
            <TextColumn ref={textWrapperRef}>
              {/* Invisible measurement span for exercise picker text */}
              <span
                ref={exercisePickerTextRef}
                style={{
                  position: 'absolute',
                  visibility: 'hidden',
                  whiteSpace: 'nowrap',
                  font: 'inherit', // IMPORTANT: match font exactly
                }}
              >
                {getName()}
              </span>
              {(isExpanded || typeDoesNotExpand() || content.preSave) && !isRecurring && typeHasSwap() ? (
                <>
                  <SelectDropdownExercisePicker
                    iconOb={iconOb}
                    setIconOb={setIconOb}
                    textWrapperRef={textWrapperRef}
                    defaultValue={{
                      name: content.title,
                      id: content.exerciseId,
                      icon: null,
                    }}
                    fullWidthInput
                    typeToFilter={content?.exercise?.type || content.type}
                    isChecked={isChecked}
                    selectedOption={selectedOption}
                    setSelectedOption={setSelectedOption}
                    addExerciseToggleMenuOpen={addExerciseToggleMenuOpen}
                    setAddExerciseToggleMenuOpen={setAddExerciseToggleMenuOpen}
                    showSelectOnStart={false}
                    assignedId={content?.assignedId}
                  />
                  {!addExerciseToggleMenuOpen && (
                    <NameTextAndDownArrowContainer maxWidth={exerciseTextNameWidth} onMouseDown={() => setAddExerciseToggleMenuOpen(!addExerciseToggleMenuOpen)}>
                      <NameText style={{ maxWidth: 'fit-content', cursor: !isAthleteAddedItem && 'pointer' }}>{getName()}</NameText>
                      <IcomoonReact
                        iconSet={iconSet}
                        size={10}
                        icon='gs-arrow-down'
                        color='rgba(189, 189, 189, 1)'
                        style={{ minWidth: 10 }}
                      />
                    </NameTextAndDownArrowContainer>
                  )}
                </>
              ) : (
                content.type === 'session_break' ? (
                  sessionBreakInputOpen && isExpanded ? (
                    <SessionBreakTable
                      contentIndex={index}
                      content={content}
                      localAdditionalInfo={localAdditionalInfo}
                      isRecurring={isRecurring}
                      nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                      setSessionBreakInputOpen={setSessionBreakInputOpen}
                      sessionBreakInputOpen={sessionBreakInputOpen}
                      itemIsHoveredByMouse={itemIsHoveredByMouse}
                      inputBox
                      date={effectiveDate}
                      dayNumber={effectiveSelectedProgramDayNumber}
                      numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                      sessionBreakInputValue={sessionBreakInputValue}
                      setSessionBreakInputValue={setSessionBreakInputValue}
                    />
                  ) : (
                    <>
                      <NameText
                        style={{ maxWidth: isExpanded && 'fit-content', cursor: !isAthleteAddedItem && 'pointer' }}
                        onClick={(e) => {
                          if (isExpanded) {
                            e.stopPropagation();
                          }
                          setSessionBreakInputOpen(true);
                        }}
                      >
                        {`${sessionBreakInputValue || getName()}${NumberOfItemsUnderSessionBreak > 0 ? ` (${NumberOfItemsUnderSessionBreak})` : ''}`}
                      </NameText>
                      {/* {only need to render hidden table once for auto save on preSave item} */}
                      {content.preSave && (
                      <SessionBreakTable
                        contentIndex={index}
                        content={content}
                        localAdditionalInfo={localAdditionalInfo}
                        isRecurring={isRecurring}
                        nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                        setSessionBreakInputOpen={setSessionBreakInputOpen}
                        sessionBreakInputOpen={sessionBreakInputOpen}
                        itemIsHoveredByMouse={itemIsHoveredByMouse}
                        inputBox
                        date={effectiveDate}
                        dayNumber={effectiveSelectedProgramDayNumber}
                        numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                        hidden
                        sessionBreakInputValue={sessionBreakInputValue}
                        setSessionBreakInputValue={setSessionBreakInputValue}
                      />
                      )}
                    </>
                  )
                ) : (
                  <NameText style={{ maxWidth: 'fit-content', cursor: !isAthleteAddedItem && 'pointer' }}>{getName()}</NameText>
                )
              )}
            </TextColumn>
            {((!isWeekView && !isAthleteAddedItem) || (isWeekView && isDayExpanded && !isAthleteAddedItem)) ? (
              <RightBox
                ref={inLineActionsContainerRef}
                onClick={(e) => e.stopPropagation()}
              >
                {(shouldShowQuickActions || isExpanded || content.preSave || isThisItemSupersetPickerOpen) && windowWidth > 575 && (
                <IconBox>
                  {inLineActionsIconDisplayer(inLineActionsObject)}
                </IconBox>
                )}
                <CalendarItemDropdownOptions
                  setCoachCompletion={setCoachCompletion}
                  setIsLeftAndRight={setIsLeftAndRight}
                  setCompletionOnly={setCompletionOnly}
                  setTrackVolumeLoad={setTrackVolumeLoad}
                  setTrackRepCount={setTrackRepCount}
                  setForcePrUpdate={setForcePrUpdate}
                  setDisablePrUpdate={setDisablePrUpdate}
                  setAssignedPace={setAssignedPace}
                  setIconOb={setIconOb}
                  handleRemovePresaveItemFromRedux={handleRemovePresaveItemFromRedux}
                  onDropdownChange={saveDropdownStateToRedux}
                  coachCompletion={coachCompletion}
                  isLeftAndRight={isLeftAndRight}
                  completionOnly={completionOnly}
                  trackVolumeLoad={trackVolumeLoad}
                  trackRepCount={trackRepCount}
                  forcePrUpdate={forcePrUpdate}
                  disablePrUpdate={disablePrUpdate}
                  assignedPace={assignedPace}
                  iconOb={iconOb}
                  setIsExpanded={setIsExpanded}
                  isExpanded={isExpanded}
                  expandId={content.assignedId}
                  contentType={typeResolver(content)}
                  index={index}
                  content={content}
                  localAdditionalInfo={localAdditionalInfo}
                  isRecurring={isRecurring}
                  isWeekView={isWeekView}
                  effectiveDate={effectiveDate}
                  dayNumber={dayNumber}
                  measure={measure}
                />
              </RightBox>
            ) : (
              <RightBoxPlaceholder />
            )}
          </ClickContainer>
          {isExpanded || content.preSave || typeDoesNotExpand() ? (
            <Subtext
              style={{ marginLeft: 7, width: isCalendarItemSavingOrUpdating ? '100%' : 'fit-content' }}
              className='add-info'
            >
              {paceDisplaySection()}
              {!excludedDescriptionTypes.includes(content.type) ? infoEditSection(content) : null}
            </Subtext>
          ) : (
            <SubTitle
              style={{
                marginLeft: 7,
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                marginRight: 18,
                maxWidth: 300,
              }}
            >
              {content.additionalInfo && (content.type === 'lift' || content.type === 'L' || content.type === 'T' || content.type === 'tag') ? `${content.subTitle} - ${decodeHtmlEntities(content.additionalInfo)}` : content.subTitle }
            </SubTitle>
          )}
          {!content.preSave ? (
            <ExpandingContainer
                /** this style is important for react virtualize to be able to dynamically expand and collpase items */
              style={{ display: !isExpanded && 'none' }}
              ref={expandingContainerRef}
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ConditionalScrollContainer ref={contentRef} style={{ overflowX: !typeHasIndividualScrollContainer() && 'scroll' }}>
                {content?.exercise?.type === 'L' ? (
                  <ExerciseTable
                    content={content}
                    index={index}
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    isLeftAndRight={isLeftAndRight}
                    trackRepCount={trackRepCount}
                    trackVolumeLoad={trackVolumeLoad}
                    forcePrUpdate={forcePrUpdate}
                    disablePrUpdate={disablePrUpdate}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'R' ? (
                  <ExerciseTableSAQC
                    content={content}
                    index={index}
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    assignedPace={assignedPace}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'C' ? (
                  <ExerciseTableCircuit
                    content={content}
                    index={index}
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'S' ? (
                  <QuestionnaireTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'W' ? (
                  <WarmupTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'N' ? (
                  <NoteTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'H' || content?.type === 'health' ? (
                  <HealthTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.exercise?.type === 'CD' ? (
                  <CooldownTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'session_break' ? (
                  <SessionBreakTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    checkBoxInput
                    itemIsHoveredByMouse={itemIsHoveredByMouse}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                    numberOfItemsUnderSessionBreak={NumberOfItemsUnderSessionBreak}
                  />
                ) : null}
                {content?.type === 'rest' ? (
                  <RestTimeTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'video' ? (
                  <VideoTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'progression' ? (
                  <ProgressionTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    isRecurring={isRecurring}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'tag' ? (
                  <TagTable
                    content={content}
                    index={index}
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    isLeftAndRight={isLeftAndRight}
                    trackRepCount={trackRepCount}
                    trackVolumeLoad={trackVolumeLoad}
                    forcePrUpdate={forcePrUpdate}
                    disablePrUpdate={disablePrUpdate}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
              </ConditionalScrollContainer>
            </ExpandingContainer>
          ) : (
            <PreSaveExpandingContainer
              onClick={(e) => {
                e.stopPropagation();
              }}
            >
              <ConditionalScrollContainer ref={contentRef} style={{ overflowX: !typeHasIndividualScrollContainer() && 'scroll' }}>
                {content?.type === 'L' ? (
                  <PreSaveTable
                    setCoachCompletion={setCoachCompletion}
                    coachCompletion={coachCompletion}
                    isLeftAndRight={isLeftAndRight}
                    setIsLeftAndRight={setIsLeftAndRight}
                    completionOnly={completionOnly}
                    setCompletionOnly={setCompletionOnly}
                    trackRepCount={trackRepCount}
                    setTrackRepCount={setTrackRepCount}
                    trackVolumeLoad={trackVolumeLoad}
                    setTrackVolumeLoad={setTrackVolumeLoad}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    forcePrUpdate={forcePrUpdate}
                    setForcePrUpdate={setForcePrUpdate}
                    disablePrUpdate={disablePrUpdate}
                    setDisablePrUpdate={setDisablePrUpdate}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'R' ? (
                  <PreSaveTableSAQC
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    assignedPace={assignedPace}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'C' ? (
                  <PreSaveTableCircuit
                    coachCompletion={coachCompletion}
                    completionOnly={completionOnly}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'S' ? (
                  <QuestionnaireTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    localDescription={localDescription}
                    swapDropdownSelectedExercise={selectedOption}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'W' ? (
                  <WarmupTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'N' ? (
                  <NoteTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'H' || content?.type === 'health' ? (
                  <HealthTable
                    // contentIndex={index}
                    // content={content}
                    // localAdditionalInfo={localAdditionalInfo}
                    // date={effectiveDate}
                    // dayNumber={effectiveSelectedProgramDayNumber}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    nonSwappedItemFromParentCalendar={nonSwappedItemFromParentCalendar}
                    isRecurring={isRecurring}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'CD' ? (
                  <CooldownTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'rest' ? (
                  <PreSaveRestTimeTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'video' ? (
                  <PreSaveVideoTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'T' ? (
                  <PreSaveTable
                    setCoachCompletion={setCoachCompletion}
                    coachCompletion={coachCompletion}
                    isLeftAndRight={isLeftAndRight}
                    setIsLeftAndRight={setIsLeftAndRight}
                    completionOnly={completionOnly}
                    setCompletionOnly={setCompletionOnly}
                    trackRepCount={trackRepCount}
                    setTrackRepCount={setTrackRepCount}
                    trackVolumeLoad={trackVolumeLoad}
                    setTrackVolumeLoad={setTrackVolumeLoad}
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    swapDropdownSelectedExercise={selectedOption}
                    forcePrUpdate={forcePrUpdate}
                    setForcePrUpdate={setForcePrUpdate}
                    disablePrUpdate={disablePrUpdate}
                    setDisablePrUpdate={setDisablePrUpdate}
                    measure={measure}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
                {content?.type === 'P' ? (
                  <PreSaveProgressionTable
                    contentIndex={index}
                    content={content}
                    localAdditionalInfo={localAdditionalInfo}
                    date={effectiveDate}
                    dayNumber={effectiveSelectedProgramDayNumber}
                  />
                ) : null}
              </ConditionalScrollContainer>
            </PreSaveExpandingContainer>
          )}
        </LineContainer>
      </ItemRow>
    </Container>
  );
};

DraggableContent.propTypes = {
  content: PropTypes.instanceOf(Object).isRequired,
  isHovered: PropTypes.bool.isRequired,
  index: PropTypes.number.isRequired,
  isRecurring: PropTypes.string,
  shouldShowQuickActions: PropTypes.bool,
  isDragging: PropTypes.bool,
  localDescription: PropTypes.string,
  setLocalDescription: PropTypes.func,
  localAdditionalInfo: PropTypes.string,
  setLocalAdditionalInfo: PropTypes.func,
  measure: PropTypes.func,
  itemHoveringOverCurrentItem: PropTypes.bool,
  itemIsHoveredByMouse: PropTypes.bool,
  isExpanded: PropTypes.bool,
  setIsExpanded: PropTypes.func,
  checkboxVisible: PropTypes.bool,
  beforeOrAfter: PropTypes.string,
  isWeekView: PropTypes.bool,
  isDayExpanded: PropTypes.bool,
  date: PropTypes.string,
  dayNumber: PropTypes.string,
  onDayExpand: PropTypes.func,
  isAthleteAddedItem: PropTypes.bool,
  athleteAddedItems: PropTypes.arrayOf(
    PropTypes.shape({
      groupingLetter: PropTypes.string,
    }),
  ),
};

DraggableContent.defaultProps = {
  isRecurring: null,
  shouldShowQuickActions: false,
  isDragging: false,
  localDescription: '',
  localAdditionalInfo: '',
  setLocalDescription: () => {},
  setLocalAdditionalInfo: () => {},
  measure: () => {},
  itemHoveringOverCurrentItem: false,
  itemIsHoveredByMouse: false,
  isExpanded: false,
  setIsExpanded: () => {},
  checkboxVisible: false,
  beforeOrAfter: '',
  isWeekView: false,
  isDayExpanded: false,
  date: null,
  dayNumber: null,
  onDayExpand: () => {},
  isAthleteAddedItem: false,
  athleteAddedItems: [],
};

export default DraggableContent;
